import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'swipe-drawer',
  templateUrl: 'swipe-drawer.html',
})
export class SwipeDrawerComponent {
  drawerOpen = false;

  @Output() open = new EventEmitter();

  constructor() {}

  handleDrawer(event) {
    this.preventDefault(event);
    setTimeout(() => {
      this.drawerOpen = !this.drawerOpen;
      this.open.emit(this.drawerOpen);
    });
  }

  preventDefault(e) {
    try {
      e.stopPropagation();
      e.preventDefault();
    } catch (e) {
      console.log('error stop prop', e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/swipe-drawer/swipe-drawer.ts